// extracted by mini-css-extract-plugin
export default {"content":"OrgPricingInfoPopup_content__uIBai","modal":"OrgPricingInfoPopup_modal__zubI5"};